import { FONT_SIZE, useChartContext, estimateStringWidth } from '@shopify/polaris-viz-core';

function useEstimateStringWidth(string, fontSize = FONT_SIZE) {
  var _characterWidthOffset;
  const {
    characterWidths,
    characterWidthOffsets
  } = useChartContext();
  const offset = (_characterWidthOffset = characterWidthOffsets.fontSize[fontSize]) !== null && _characterWidthOffset !== void 0 ? _characterWidthOffset : 1;
  const width = estimateStringWidth(string, characterWidths);
  return width * offset;
}

export { useEstimateStringWidth };
